module.exports = __webpack_public_path__ + "static/media/why-doorbadge.3f7c208f.jpg";